document.addEventListener("DOMContentLoaded", function () {
  const articleContent = document.querySelector('.js-article-content');
  const tocList = document.getElementById('toc-list');

  if (!articleContent || !tocList) return;

  const headings = articleContent.querySelectorAll('h2, h3');
  if (headings.length === 0) return;

  headings.forEach((heading, index) => {
    // 見出しにIDを付与
    const id = `heading-${index}`;
    heading.id = id;

    // 目次に追加
    const listItem = document.createElement('li');
    listItem.innerHTML = `<a href="#${id}">${heading.innerText}</a>`;

    // h3 の場合、h2 の下にネストする
    if (heading.tagName.toLowerCase() === 'h3' && tocList.lastElementChild) {
      let lastLi = tocList.lastElementChild;
      let subList = lastLi.querySelector("ul");
      if (!subList) {
        subList = document.createElement("ul");
        lastLi.appendChild(subList);
      }
      subList.appendChild(listItem);
    } else {
      tocList.appendChild(listItem);
    }
  });


  const tocToggle = document.querySelector(".js-toc-toggle");

  if (!tocToggle || !tocList) return;

  tocToggle.addEventListener("click", function () {
    if (tocList.style.display === "none") {
      tocList.style.display = "block";
      tocToggle.textContent = "閉じる";
    } else {
      tocList.style.display = "none";
      tocToggle.textContent = "開く";
    }
  });
});